module.exports = __webpack_public_path__ + "img/LUB00393.749a552f.png";